export default `
  <div data-translate="popupSetNameHint" id="set_name_hint"></div>
  <div data-translate="popupSetNameRules"></div>
  <div class="md-input" id="set_name_input_wrapper">
    <input type="text" class="has-value" id="set_name_input" />
    <label id="set_name_label" data-translate="popupSetNameLabel"></label>
    <div class="bar"></div>
  </div>
  <p id="set_name_msg">&nbsp;</p>
`;
